export function setupServicesLoadMore( selector = '.services__load-more' ) {
	const wraps = document.querySelectorAll( selector );
	if ( !wraps[0] ) {
		return;
	}

	for ( let i = 0; i < wraps.length; i++ ) {
		setupWrap( wraps[i] );
	}

	function setupWrap( wrap ) {
		const button = wrap.querySelector( 'button' );
		const block = wrap.closest( '.landing-blocks__block--services' );
		const list = block ? block.querySelector( '.services__list' ) : null;

		if ( !button || !list ) {
			return;
		}

		button.addEventListener( 'click', () => {
			list.classList.remove( 'services__list--collapsed' );
			wrap.remove();
		} );
	}
}
